/*eslint-disable*/
import React from "react";
import FooterLayout from "./FooterLayout";
import FooterMain from "./FooterMain";
import FooterMenu from "./FooterMenu";
import { isAuthenticated } from "utils/common";

function Footer() {
  return (
    <footer className={`${isAuthenticated() ? "auth" : ""}`}>
      <FooterLayout>
        <FooterMenu />
      </FooterLayout>
      <FooterMain />
    </footer>
  );
}

export default Footer;
